const APP_ROUTE_BASE = "/cards-ui";
const DASHBOARD_BASE = APP_ROUTE_BASE + "/client";

export const ROUTES = {
  BASE: "/",
  APP_BASE: APP_ROUTE_BASE,
  LOGIN: APP_ROUTE_BASE + "/authenticate/login",
  VERIFY_OTP: APP_ROUTE_BASE + "/authenticate/verify-otp",
  FORGOT_PASSWORD: APP_ROUTE_BASE + "/authenticate/forgot-password",
  REGION: APP_ROUTE_BASE + "/authenticate/region",
  DEFAULT_PASSWORD: APP_ROUTE_BASE + "/authenticate/default-password",
  RESET_PASSWORD: APP_ROUTE_BASE + "/authenticate/resetPassword",
  LOGOUT: APP_ROUTE_BASE + "/authenticate/logout",
  NO_MATCH_ROUTE: APP_ROUTE_BASE + "*",

  // Dashboard Routes
  DASHBOARD_BASE: DASHBOARD_BASE,
  DASHBOARD: DASHBOARD_BASE + "/dashboard",
  PROFILE: DASHBOARD_BASE + "/profile",

  // Cards
  CARDS: {
    INDEX: DASHBOARD_BASE + "/cards",
    PREFUND_REQUEST: DASHBOARD_BASE + "/cards/prefund-request",
  },

  // Driver
  DRIVERS: {
    INDEX: DASHBOARD_BASE + "/drivers",
    ONBOARD: DASHBOARD_BASE + "/drivers/onboard",
  },

  // Reporting
  REPORTS: {
    INDEX: DASHBOARD_BASE + "/reporting",
    CARD_LOAD: DASHBOARD_BASE + "/reporting/card-load",
    PREFUND: DASHBOARD_BASE + "/reporting/prefund",
    LEDGER: DASHBOARD_BASE + "/reporting/ledger",
    B2B: DASHBOARD_BASE + "/reporting/b2b",
    DRIVER_PAYMENT_REQ: DASHBOARD_BASE + "/reporting/payment-requests",
  },

  // Requests
  REQUESTS: {
    INDEX: DASHBOARD_BASE + "/requests",
    CARD_LOAD: DASHBOARD_BASE + "/requests/card-load",
    PREFUND: DASHBOARD_BASE + "/requests/prefund",
    B2B: DASHBOARD_BASE + "/requests/b2b-payments",
    DRIVER_PAYMENT_REQ: DASHBOARD_BASE + "/requests/payment-requests",
  },

  // Settings
  SETTINGS: {
    INDEX: DASHBOARD_BASE + "/settings",
    USERS: DASHBOARD_BASE + "/settings/users",
    SECURITY: DASHBOARD_BASE + "/settings/security",
    USAGE_REPORT: DASHBOARD_BASE + "/settings/usage",
    HELP: DASHBOARD_BASE + "/settings/help",
    ACCOUNT_DETAILS: DASHBOARD_BASE + "/settings/account-details",
    EXPENSE_MANAGEMENT: DASHBOARD_BASE + "/settings/expense-management",
  },

  // Store
  STORE: {
    INDEX: DASHBOARD_BASE + "/store",
    HOME: DASHBOARD_BASE + "/store/promotions",
    PRODUCT_BASE: DASHBOARD_BASE + "/store/product",
    PRODUCTS: DASHBOARD_BASE + "/store/products",
    PRODUCT: DASHBOARD_BASE + "/store/product/:productId",
    CART: DASHBOARD_BASE + "/store/cart",
    ORDERS: DASHBOARD_BASE + "/store/order",
    ORDER_VIEW: DASHBOARD_BASE + "/store/order/:id",
  },
  // Bulk Operations
  BULK_OPERAION: {
    INDEX: DASHBOARD_BASE + "/bulk",
    LOAD_CARD: DASHBOARD_BASE + "/bulk/cards",
    LOAD_DRIVER: DASHBOARD_BASE + "/bulk/drivers",
    CARD_SUMMARY: DASHBOARD_BASE + "/bulk/summary-card",
    DRIVER_SUMMARY: DASHBOARD_BASE + "/bulk/summary-driver",
  },

  // wps
  WPS: {
    INDEX: DASHBOARD_BASE + "/wps",
    EMPLOYEE_LIST: DASHBOARD_BASE + "/wps/transporter/employee-details",
    RECENT_PAID_SALARY: DASHBOARD_BASE + "/wps/salary-details",
    GENERATE_SALARY: DASHBOARD_BASE + "/wps/transporter/generate-salary",
  },
};
